import { render, staticRenderFns } from "./dictionaryPopup.vue?vue&type=template&id=23233dd8&"
import script from "./dictionaryPopup.vue?vue&type=script&lang=js&"
export * from "./dictionaryPopup.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryPopup.vue?vue&type=style&index=0&id=23233dd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports